// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nan-9","right":"Footer_right__1uFxu","buttons":"Footer_buttons__3ZHhj"};